// UpdateImgForm.js

import React, { useContext, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "../context/ProductsProvider";
import { useAuthContext } from "../context/AuthContext";
import Firestore from "../handlers/firestore";
import Storage from "../handlers/storage";
import { FaArrowLeft } from 'react-icons/fa';
import  "./Slider.css";

const { updateProduct } = Firestore;
const { uploadFile, downloadFile } = Storage;

const Preview = ({ path }) => {
  return (
    path && (
      <div
        className="rounded p-1 m-5"
        style={{
          width: "300px",
          height: "300px",
          backgroundImage: `url(${path})`,
          backgroundSize: "cover",
        }}
      ></div>
    )
  );
};

function UpdateImgForm() {
  const { state, dispatch, read } = useContext(Context);
  const { currentUser } = useAuthContext();
  const location = useLocation();
  const navigate = useNavigate();
  const { inputs, items } = state;

  const { id: itemId } = location.state || {};

  const [successMessage, setSuccessMessage] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    const currentItem = items.find((item) => item.id === itemId);
    if (currentItem) {
      dispatch({ type: "updateInputs", payload: { value: currentItem } });
    }
  }, [dispatch, items, itemId]);

  const handleOnChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file" && files.length > 0) {
      // Get the selected file
      const selectedFile = files[0];
      // Update the inputs state with the selected file and its path
      dispatch({
        type: "updateInputs",
        payload: {
          value: {
            ...inputs,
            file: selectedFile,
            path: URL.createObjectURL(selectedFile),
          },
        },
      });
    }
  };
  

  const username = currentUser?.displayName?.split(" ").join("") || "";

  const handleOnSubmit = (e) => {
    e.preventDefault();

    // Client-side validation
    if (!inputs.file) {
        alert("Please select an image.");
        return;
    }

    if (isSubmitting) return; // Prevent multiple submissions
    setIsSubmitting(true); // Set submitting state to true

    uploadFile(inputs)
      .then(downloadFile)
      .then((url) => {
        updateProduct({ ...inputs, path: url, user: username.toLowerCase() }, "products", itemId)
          .then(() => {
            read();
            setSuccessMessage("Product image updated successfully!");
            // Clear form inputs
            dispatch({ type: "resetInputs" });
            setIsSubmitting(false); // Reset submitting state
            // Reset success message after 3 seconds
            setTimeout(() => {
              setSuccessMessage(null);
            }, 3000);
          })
          .catch((error) => {
            console.error("Error updating product image:", error);
            setSuccessMessage("Error updating product image.");
            setIsSubmitting(false); // Reset submitting state
          });
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
        setSuccessMessage("Error uploading image.");
        setIsSubmitting(false); // Reset submitting state
      });
  };

  return (
    <>
      <FaArrowLeft className="arrow_add" onClick={() => { navigate(-1) }} />
      {successMessage && (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {successMessage}
          <button type="button" className="btn-close" aria-label="Close" onClick={() => setSuccessMessage(null)}></button>
        </div>
      )}
      <p className="display-6 text-center mb-3">Update Product Image</p>
      <div className="mb-5 d-flex align-items-center justify-content-center">
        <form
          className="mb-2"
          style={{ textAlign: "left" }}
          onSubmit={handleOnSubmit}
        >
          <div className="mb-3">
            <label htmlFor="file" className="form-label">
              Choose Image:
            </label>
            <input
              type="file"
              className="form-control"
              id="file"
              name="file"
              accept="image/*"
              onChange={handleOnChange}
            />
          </div>
          <div className="mb-3">
            <Preview path={inputs.path} />
          </div>
          <button
            type="submit"
            className="btn btn-primary"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Updating..." : "Update Image"}
          </button>
        </form>
      </div>
    </>
  );
}

export default UpdateImgForm;
